import { render } from "./TransactionsParameters.vue?vue&type=template&id=2206a0b3"
import script from "./TransactionsParameters.vue?vue&type=script&lang=js"
export * from "./TransactionsParameters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Reports/Agent/TransactionsParameters.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2206a0b3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2206a0b3', __exports__)) {
    api.reload('2206a0b3', __exports__)
  }
  
  module.hot.accept("./TransactionsParameters.vue?vue&type=template&id=2206a0b3", () => {
    api.rerender('2206a0b3', render)
  })

}


export default __exports__